import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconSocialMediaLinkedIn.module.css';

const IconSocialMediaLinkedIn = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <path d="M42 37a5 5 0 01-5 5H11a5 5 0 01-5-5V11a5 5 0 015-5h26a5 5 0 015 5v26z" />
      <path
        d="M30 37V26.901c0-1.689-.819-2.698-2.192-2.698-.815 0-1.414.459-1.779 1.364-.017.064-.041.325-.031 1.114L26 37h-7V18h7v1.061C27.022 18.356 28.275 18 29.738 18c4.547 0 7.261 3.093 7.261 8.274L37 37h-7zm-19 0V18h3.457C12.454 18 11 16.528 11 14.499 11 12.472 12.478 11 14.514 11c2.012 0 3.445 1.431 3.486 3.479C18 16.523 16.521 18 14.485 18H18v19h-7z"
        opacity="0.05"
      />
      <path
        d="M30.5 36.5v-9.599c0-1.973-1.031-3.198-2.692-3.198-1.295 0-1.935.912-2.243 1.677-.082.199-.071.989-.067 1.326L25.5 36.5h-6v-18h6v1.638c.795-.823 2.075-1.638 4.238-1.638 4.233 0 6.761 2.906 6.761 7.774L36.5 36.5h-6zm-19 0v-18h6v18h-6zm2.957-19c-1.713 0-2.957-1.262-2.957-3.001 0-1.738 1.268-2.999 3.014-2.999 1.724 0 2.951 1.229 2.986 2.989 0 1.749-1.268 3.011-3.015 3.011h-.028z"
        opacity="0.07"
      />
      <path d="M12 19h5v17h-5V19zm2.485-2h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99-.144.35-.101 1.318-.101 1.807v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36z" />
    </svg>
  );
};

IconSocialMediaLinkedIn.defaultProps = { rootClassName: null, className: null };

const { string } = PropTypes;

IconSocialMediaLinkedIn.propTypes = { rootClassName: string, className: string };

export default IconSocialMediaLinkedIn;
